import styled from '@emotion/styled'

export const UserDropDownItemStyle = styled.div`
  min-height: 40px;
  line-height: 40px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  padding-left: 24px;
  font-size: 14px;
  color: var(--ow-color-darkTheme-1400);
  font-weight: var(--font-weight-400);
  align-items: center;
  .label {
    width: 80px;
    opacity: 0.6;
    line-height: 1.5;
  }
  .value {
    flex: 1;
    opacity: 0.9;
    line-height: 1.5;
  }
  button {
    width: 40px;
    height: 24px;
    color: var(--ow-color-primary-700);
    font-size: 12px;
    border: 1px solid var(--ow-color-primary-700);
    border-radius: 4px;
    margin-left: 8px;
  }
`

export const LogoutStyled = styled.div`
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: center;
  border-top: 1px solid var(--ow-color-neutral-200);
  span {
    flex: 1;
    text-align: center;
    font-size: 14px;
    font-weight: var(--font-weight-400);
    color: var(--text-darkTheme-1400);
    cursor: pointer;
  }
  .logout {
    color: var(--ow-color-error-500);
    cursor: pointer;
  }
`
